import{IconDash100 as e}from"../src/elements/IconDash100.js";customElements.define("sp-icon-dash100",e);
//# sourceMappingURL=sp-icon-dash100.js.map
